import { EKeyCode } from '@/enums/e_key_code';
import { WATCHER_SHORTCUT__base } from '@/pages/_base/shortcuts/_watchers/WATCHER_SHORTCUT__base';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { RefObject } from 'react';

interface Props {
  password: string;
  ref_email: RefObject<HTMLInputElement>;
  ref_password: RefObject<HTMLInputElement>;
  ref_button_auth_magic_link: RefObject<HTMLButtonElement>;
  ref_button_auth_email_and_password: RefObject<HTMLButtonElement>;
}

export function WatcherAuthInputAcceptValue({ password, ref_email, ref_password, ref_button_auth_magic_link, ref_button_auth_email_and_password }: Props) {
  function on_shortcut_pressed() {
    let out = false;

    assert_not_null(ref_email.current);
    assert_not_null(ref_password.current);
    assert_not_null(ref_button_auth_magic_link.current);
    assert_not_null(ref_button_auth_email_and_password.current);

    if (document.activeElement === ref_email.current) {
      ref_password.current.focus();
      out = true;
    } else if (document.activeElement === ref_password.current) {
      password.trim() ? ref_button_auth_email_and_password.current.click() : ref_button_auth_magic_link.current.click();
      out = true;
    }

    return out;
  }

  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.Enter]} {...{ on_shortcut_pressed }} />;
}
